import { render } from "./ProjectPage.vue?vue&type=template&id=0eb54648&ts=true"
import script from "./ProjectPage.ts?vue&type=script&lang=ts"
export * from "./ProjectPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__